module.exports = __webpack_public_path__ + "img/IMAGE 7.55ec687a.png";